<script lang="ts" setup>
  import type { TOrientation } from '~/composables/deviceParams';
  import { EOrientation, useOrientation } from '~/composables/deviceParams';
  import SupportChat from '~/utils/services/support-chat.service';

  const emit = defineEmits<{ close: [] }>();

  const { orientation } = useOrientation();
  const { isDesktop } = useDeviceType();

  const videoSrc = ref('');
  const videoElement = ref<HTMLVideoElement | null>(null);

  watch(orientation, setVideoSourceByOrientation, { immediate: true });
  watch(videoSrc, setMaxVideoVolume);

  onMounted(() => {
    SupportChat.hideButton();
  });

  onBeforeUnmount(() => {
    SupportChat.showButton();
  });

  async function setVideoSourceByOrientation(newOrientation: TOrientation) {
    videoSrc.value = '';

    await nextTick();

    if (isDesktop.value) {
      videoSrc.value = '/videos/andy-ruiz/MaxDuel_Andy-Ruiz-Jr_16-9_Website.mp4';
    } else {
      videoSrc.value =
        newOrientation === EOrientation.PORTRAIT
          ? '/videos/andy-ruiz/MaxDuel_Andy-Ruiz-Jr_9-16_Website.mp4'
          : '/videos/andy-ruiz/MaxDuel_Andy-Ruiz-Jr_16-9_Website.mp4';
    }
  }

  async function setMaxVideoVolume() {
    await nextTick();
    if (!videoElement.value) return;
    videoElement.value.volume = 0.5;
  }
</script>

<template>
  <UModal
    title="MaxDuel Promotional Video"
    description="MaxDuel Promotional Video"
    :close="{ onClick: () => emit('close') }"
  >
    <template #content>
      <video v-if="videoSrc" ref="videoElement" autoplay controls playsinline webkit-playsinline width="100%">
        <source :src="videoSrc" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <CoreIcon
        class="size-10 absolute top-2 right-2 cursor-pointer rotate-45"
        name="i-lucide-circle-plus"
        @click="emit('close')"
      />
    </template>
  </UModal>
</template>
